import ApiClient from "../ampm-world";
import { ProductListResource } from "../generated-api";
import { FavoriteListRequestType } from "./types";

export class ApiFavorite {
  static async getFavorites(params: FavoriteListRequestType, lang: string): Promise<ProductListResource> {
    return ApiClient.get<ProductListResource>(`/${lang}/favorites`, {
      page_size: params.pageSize,
      page_number: params.pageNumber,
      product_guids: params.productGuids,
    });
  }
}
